import { ROUTES } from '@aibees/elephant/router';
import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Button, Typography } from '@mui/material';
import { memo } from 'react';
import { useEmployeeCardHeaderData } from '../../hooks/use-employee-card-header-data';
import * as Styled from './styles';
import * as SX from './sx';
import type { EmployeeCardHeaderProps as Props } from './types';

export const EmployeeCardHeader = memo(({ className }: Props) => {
  const { currentItem } = useEmployeeCardHeaderData();

  const handleClick = () => {
    window.open(
      ROUTES.companyEmployees.replace(':id', String(currentItem?.id)),
      '_blank'
    );
  };

  return (
    <Styled.Wrapper
      className={classnames('EmployeeCardHeader', className)}
      sx={SX.root}
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      p={1.5}
    >
      <Typography variant="body2" fontWeight={600} color="grey.700">
        Employees
      </Typography>
      <Button
        endIcon={<Icon name="chevron-right" size={20} />}
        onClick={handleClick}
        variant="outlined"
        color="default"
        size="xsmall"
      >
        Show All Results
      </Button>
    </Styled.Wrapper>
  );
});

EmployeeCardHeader.displayName = 'EmployeeCardHeader';
